import { render, staticRenderFns } from "./cableClamp.vue?vue&type=template&id=ce422828&scoped=true"
import script from "./cableClamp.vue?vue&type=script&lang=js"
export * from "./cableClamp.vue?vue&type=script&lang=js"
import style0 from "./cableClamp.vue?vue&type=style&index=0&id=ce422828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce422828",
  null
  
)

export default component.exports